import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { PolicyAssignment } from './model';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'graphCompliancePolicyWindows10';

export interface State extends EntityState<PolicyAssignment>, Status {}

export const adapter: EntityAdapter<PolicyAssignment> = createEntityAdapter<PolicyAssignment>();

export const initialState: State = adapter.getInitialState({
    ...initialStatus,
});

export const reducer = createReducer(
    initialState,
    // load

    on(actions.loadCompliancePoliciesSuccess, (state, action) =>
        adapter.upsertMany(action.data, { ...state, loaded: true, error: null, updating: false, creating: false }),
    ),

    on(actions.reloadCompliancePoliciesSuccess, (state, action) =>
        adapter.upsertMany(action.data, { ...state, loaded: true, error: null, updating: false, creating: false }),
    ),

    on(actions.loadCompliancePoliciesFailure, (state, { error }) => ({
        ...state,
        error,
        loaded: false,
    })),

    // create
    on(actions.createCompliancePolicy, (state, action) => ({
        ...state,
        updating: true,
        error: null,
    })),

    on(actions.createCompliancePolicyFailure, (state, { error }) => ({
        ...state,
        error,
        updating: false,
    })),

    on(actions.createCompliancePolicyFailure, (state, { error }) => ({
        ...state,
        error,
        updating: false,
    })),

    //update
    on(actions.updateCompliancePolicy, (state, action) => ({
        ...state,
        updating: true,
        error: null,
    })),

    on(actions.updateCompliancePolicyFailure, (state, { error }) => ({
        ...state,
        error,
        updating: false,
    })),

    // delete
    on(actions.deleteCompliancePolicy, (state, action) => ({
        ...state,
        updating: true,
        error: null,
    })),

    on(actions.deleteCompliancePolicySuccess, (state, action) =>
        adapter.removeOne(action.id, { ...state, updating: false, creating: false, error: null }),
    ),

    on(actions.deleteCompliancePolicyFailure, (state, { error }) => ({
        ...state,
        error,
    })),
);

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
